// import React from "react";
import "./BudgetTotalYearCard.scss";
import inconBudgetCard from "../../../assets/image/budget/icon-budget-card.svg";
// import { useContext } from "react";
// import { extractYear } from "../../../utils/format";
// import { AppContext } from "../../../context/Context";
const BudgetTotalYearCard = ({ title, totalBudget, agentCommissionBudget, expensesBudget }) => {
  // const { dataRange } = useContext(AppContext);
  // const targetYear = extractYear(dataRange);
  // // Handle case when data is undefined or null
  // if (!data) {
  //   return (
  //     <div className="budget-total-card__loading">Loading budget data...</div>
  //   );
  // }

  // // Safely access arrays with fallback to empty array
  // // const totalSum = (data.budgetmonths || [])
  // //   .map((item) => item.Value)
  // //   .reduce((acc, curr) => acc + curr, 0);

  // // console.log("month", data.budgetmonths);

  // function getPreviousMonth() {
  //   const now = new Date();
  //   now.setMonth(now.getMonth() - 1);
  //   const year = now.getFullYear();
  //   const month = String(now.getMonth() + 1).padStart(2, "0");
  //   return `${year}-${month}`; // Fixed template literal
  // }

  // const prevMonth = getPreviousMonth();
  // // console.log("Previous Month:", prevMonth);

  // const filtered = (data.budgetmonths || []).filter(
  //   (item) => item.year_month <= prevMonth
  // );
  // // console.log("Filtered entries:", filtered);

  // const totalSum = filtered
  //   .filter((item) => {
  //     const year = item.year_month.split("-")[0];
  //     if (targetYear === "All") return true;
  //     return year === targetYear;
  //   })
  //   .reduce((acc, curr) => acc + curr.Value, 0);

  // // console.log("Total Sum:", targetYear);

  // // const totalSumCOGS = (data.budgetcogs || [])
  // //   .map((item) => item.Value)
  // //   .reduce((acc, curr) => acc + curr, 0);

  // const filtered2 = (data.budgetcogs || []).filter(
  //   (item) => item.year_month <= prevMonth
  // );

  // const totalSumCOGS = filtered2
  //   .filter((item) => {
  //     const year = item.year_month.split("-")[0];
  //     if (targetYear === "All") return true;
  //     return year === targetYear;
  //   })
  //   .reduce((acc, curr) => acc + curr.Value, 0);

  // // const totalSumExpensesMonth = (data.budgetexpensesmonth || [])
  // //   .map((item) => item.Value)
  // //   .reduce((acc, curr) => acc + curr, 0);

  // const filtered3 = (data.budgetexpensesmonth || []).filter(
  //   (item) => item.year_month <= prevMonth
  // );
  // const totalSumExpensesMonth = filtered3
  //   .filter((item) => {
  //     const year = item.year_month.split("-")[0];
  //     if (targetYear === "All") return true;
  //     return year === targetYear;
  //   })
  //   .reduce((acc, curr) => acc + curr.Value, 0);

  const formatCurrency = (num) => {
    const formatted = Math.abs(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return num < 0 ? `($${formatted})` : `$${formatted}`;
  };

  return (
    <div className="budget-total-card">
      {/* Header with icon and title */}
      <div className="budget-total-card__header">
        {/* <div className="budget-total-card__icon-container">
          <img src={inconBudgetCard} alt="icon-budget" />
        </div> */}
        <h1 className="budget-total-card__title">
          {title}
        </h1>
      </div>

      {/* Main amount */}
      <div className="budget-total-card__main-amount-container">
        <h2 className="budget-total-card__main-amount">
          {formatCurrency(totalBudget)}
        </h2>
      </div>

      {/* Divider line */}
      <div className="budget-total-card__divider"></div>

      {/* Budget breakdown */}
      <div className="budget-total-card__breakdown-container-budget">
        <div className="budget-total-card__breakdown-item">
          <h3 className="budget-total-card__breakdown-label">
            AGENT'S COMMISSION BUDGET
          </h3>
          <p className="budget-total-card__breakdown-value">
            {formatCurrency(agentCommissionBudget)}
          </p>
        </div>
        <div className="budget-total-card__breakdown-item">
          <h3 className="budget-total-card__breakdown-label">
            EXPENSES BUDGET
          </h3>
          <p className="budget-total-card__breakdown-value">
            {formatCurrency(expensesBudget)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BudgetTotalYearCard;
